export default __webpack_public_path__ + "static/media/sentinel-nfc-3-pack.e14bfb27.png";